/* eslint-disable react-refresh/only-export-components */
export function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]; // Swap elements
  }
  return array;
}

export function getRandomProfileEmoji() {
  const images = [
    "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/1720512997488-20240709-134316.599-1.webp",
    "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/1720513111284-20240709-134316.599-2.webp",
    "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/1720513137656-20240709-134316.599-3.webp",
    "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/1720513177763-20240709-134316.599-4.webp",
    "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/1720513223692-20240709-134316.599-5.webp",
    "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/1720513247837-20240709-134316.599-6.webp",
    "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/1720513285880-20240709-134316.599-7.webp",
    "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/1720513317276-20240709-134316.599-8.webp",
    "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/1720513361014-20240709-134316.599-9.webp",
    "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/1720513392352-20240709-134316.599-10.webp",
  ];

  return images[Math.floor(Math.random() * images.length)];
}

export const OpenInNewWindow = ({ link }: { link: string }) => {
  if (!/^https?:\/\//i.test(link)) {
    const newlink = "https://" + link;
    return window.open(newlink, "_blank");
  }
  window?.open(link, "_blank");
};

export const LoaderMessages = [
  // Facts
  "Influencer marketing is much more profitable than print marketing!",
  "Businesses earn a whopping 650% return for every $1 in influencer marketing!",
  "Women now turn to influencers for product advice instead of friends!",
  "2016 marked a milestone: Influencer marketing surpassed print! A shift in the ad landscape!",
  "2024 update: 67.6% of global marketers think discovering 'relevant' influencers is a major challenge!",
  "Did you know? Over 80% of brand marketing comes from influencer collaborations. Don't miss out on the trend!",

  // Aspirational Past Campaigns with Results
  "Nykaa's 'Clay it Cool' campaign reached 3 million impressions in 2 days - a testament to influencer power!",
  "In March 2023, CRED's campaign, CRED Escapes, got 100M impressions, captivating young, affluent professionals and driving significant bookings!",
  "Sugar Cosmetics' 'Be Your Own Muse' campaign in March 2023 was a huge success: 1M+ engagements & massive surge in sales!",
  "Wonderchef's powerful campaign 'Dear Man Hold the Pan' sparked 2M reach and 5 Lakh engagements! Gender equality in action!",

  // Puns/Jokes
  "We're loading your perfect influencer matches faster than the time it takes for influencers to reply to DMs.",

  // Creator Facts
  "Influencers sift through about 4 collab proposals monthly, selecting only the best!",

  // Creator Puns/Jokes
  "Fun fact: LinkedIn has more than 55 million registered companies listed! We promise our wait won't be that long.",
  "Why did the influencer bring a ladder to the photoshoot? To reach the 'top' of their game!",
  "Your profile is loading faster than an influencer's followers after a viral post! Get ready for fame.",
  "Loading your success story... Spoiler alert: It involves lots of 'likes' and brand partnerships!",

  // Creator Ethos of the Company
  "We're loading your future success... And trust us, it's worth the wait.",
  "Your next big brand partnership is just a tap away. We're working hard to make it happen!",
  "Patience is a virtue, especially when it leads to incredible collaborations. Hang in there!",
  "The more complete your profile, the closer you are to stardom. Keep those chips coming!",
];

export const UseCasesList = [
  {
    title: "Founder Story",
    description: (
      <>
        Share why the founders Started, their inspiration. struggles, wins, and
        vision.
        <br />
        <br />
        Why?
        <br />
        <b>Because people relate to stories</b>, promoting your company
        naturally. So, showcase your journey to connect with your audience
        authentically.
      </>
    ),
    image_link:
      "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/Founder+Story.png",
  },
  {
    title: "Product/Waitlist Launch",
    description: (
      <>
        Get more support for your launch on{" "}
        <b>Product Hunt, feature launch, or waitlist</b> by getting influencers
        to announce it.
        <br />
        <br />
        This can help you{" "}
        <b>gain visibility and attract more users & early adopters.</b>
      </>
    ),
    image_link:
      "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/productLaunch.png",
  },
  {
    title: "Testimonials",
    description: (
      <>
        Let a wider audience know that your clients are saying good things about
        you on your website.
        <br />
        By sharing the positive feedback and impact you've made in people's
        lives, <b>you can encourage others to trust you & buy from you.</b>
      </>
    ),
    image_link:
      "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/TESTIMONIAL.png",
  },
  {
    title: "PR/Investment",
    description: (
      <>
        When professionals and credible people on LinkedIn talk about you, it
        lends you credibility.
        <br />
        <br />
        You can enhance your PR and give investors something substantial to read
        about you online, <b>especially when raising funds.</b>
      </>
    ),
    image_link:
      "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/PR.png",
  },
  {
    title: "Hiring",
    description: (
      <>
        Struggling to reach & hire quality people? Reach candidates on LinkedIn
        through influencers who regularly post job openings.
        <br />
        <br />
        Jobseekers follow them dedicatedly giving you{" "}
        <b>applicants of a better quality, along with increased visibility.</b>
      </>
    ),
    image_link:
      "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/HIRING.png",
  },
  {
    title: "Promotional Offers",
    description: (
      <>
        Everyone loves special discounts. Leverage influencers to promote these
        special offers for occasions like{" "}
        <b>Diwali, Christmas, or your company anniversary.</b>
        <br />
        <br />
        Personalized discount coupons for influencers are a great way to{" "}
        <b>boost your sales & product enquiries</b> effectively.
      </>
    ),
    image_link:
      "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/PROMOTION.png",
  },
  // More use cases...
];

export const CampaignCreationSteps = [
  {
    step: 1,
    title: "Input Details",
    description: (
      <>
        Provide basic details of the campaign you want to execute, like the
        campaign's purpose, budget and desired influencer type. <br /> Share
        images of the product/service you want to promote, its reference links,
        and a brief outlining the perspective you want influencers to cover.
      </>
    ),
    image:
      "https://cdn.pixabay.com/photo/2017/08/30/01/05/milky-way-2695569_960_720.jpg",
  },
  {
    step: 2,
    title: "Activate the Campaign",
    description: (
      <>
        Pay a token amount, adjusted to your overall budget, to initiate the
        campaign. Influencers receive your campaign details and start working.
      </>
    ),
    image:
      "https://cdn.pixabay.com/photo/2017/08/30/01/05/milky-way-2695569_960_720.jpg",
    note: "This payment is non-refundable if the campaign is forfeited in the middle.",
  },
  {
    step: 3,
    title: "Review",
    description: (
      <>
        Influencers submit a content draft based on your outline and their
        audience preferences. You can review and approve the content or suggest
        corrections (limited to one round of edits).
      </>
    ),
    image:
      "https://cdn.pixabay.com/photo/2017/08/30/01/05/milky-way-2695569_960_720.jpg",
  },
  {
    step: 4,
    title: "Wallet Top-Up",
    description: (
      <>
        Add funds to your campaign wallet based on estimated outcomes.If actual
        performance is:{" "}
        <ol className="list-disc ml-4">
          <li>Less than estimated, the remaining amount is refunded.</li>
          <li>
            More than estimated, you'll be alerted to either stop or continue
            the campaign. Continuing requires recharging your wallet; otherwise,
            the campaign will stop once the balance is exhausted.
          </li>
        </ol>
      </>
    ),
    image:
      "https://cdn.pixabay.com/photo/2017/08/30/01/05/milky-way-2695569_960_720.jpg",
    note: " Stopping an influencer marketing campaign means the influencer will have the option to delete/archive the post. They may or may not do it, as per their discretion.",
  },
  {
    step: 5,
    title: "Go Live",
    description:
      "On the start date, influencers share the posts on their feeds. Track live metrics on your dashboard.",
    image:
      "https://cdn.pixabay.com/photo/2017/08/30/01/05/milky-way-2695569_960_720.jpg",
  },
];

export const isDevice = () => {
  const useragent = navigator.userAgent;
  const mobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      useragent
    ) || window.innerWidth < 768;
  const desktop =
    /Windows|Linux|Macintosh/i.test(useragent) || window.innerWidth >= 768;
  return { mobile, desktop };
};

export const isValidUrl = (str: string) => {
  const urlRegex =
    /^(https?|ftp):\/\/((([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})|localhost)(:\d{2,5})?(\/[^\s]*)?$/;
  return urlRegex.test(str?.trim());
};

export function getOrdinalSuffix(number) {
  const suffixes = ["th", "st", "nd", "rd"];
  const value = number % 100;
  return (
    number + (suffixes[(value - 20) % 10] || suffixes[value] || suffixes[0])
  );
}

/**
 * Generates a random token of the specified length.
 *
 * This function uses the Web Crypto API to generate a cryptographically secure
 * random token if available. If the Web Crypto API is not available, it falls
 * back to using `Math.random()` to generate the token.
 *
 * @param {number} [length=16] - The length of the token to generate. Defaults to 16.
 * @returns {string} A random token of the specified length.
 */

export function generateRandomToken(length: number = 16) {
  if (window.crypto && window.crypto.getRandomValues) {
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array);
    return Array.from(array, (byte) => byte.toString(16).padStart(2, "0"))
      .join("")
      .substring(0, length);
  } else {
    let token = "";
    while (token.length < length) {
      token += Math.random().toString(36).substring(2);
    }
    return token.substring(0, length);
  }
}

interface ShareOptions {
  title?: string;
  text?: string;
  url?: string;
  files?: File[];
  onSuccess?: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onError?: (error: any) => void;
}

export const shareContent = (options: ShareOptions): boolean => {
  if (!navigator.share) {
    console.error("Web Share API is not supported in this browser");
    return false;
  }

  const shareData: ShareData = {
    title: options.title,
    text: options.text,
    url: options.url,
  };

  if (
    options.files &&
    navigator.canShare &&
    navigator.canShare({ files: options.files })
  ) {
    shareData.files = options.files;
  }

  navigator
    .share(shareData)
    .then(() => {
      console.log("Content shared successfully");
      if (options.onSuccess && typeof options.onSuccess === "function") {
        options.onSuccess();
      }
    })
    .catch((error) => {
      console.error("Error sharing content:", error);
      if (options.onError && typeof options.onError === "function") {
        options.onError(error);
      }
    });

  return true;
};

interface CopyToClipboardOptions {
  text: string;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const copyToClipboard = (options: CopyToClipboardOptions): boolean => {
  if (!navigator.clipboard) {
    console.error("Clipboard API is not supported in this browser");
    return false;
  }

  navigator.clipboard
    .writeText(options.text)
    .then(() => {
      console.log("Text copied to clipboard successfully");
      if (options.onSuccess && typeof options.onSuccess === "function") {
        options.onSuccess();
      }
    })
    .catch((error) => {
      console.error("Error copying text to clipboard:", error);
      if (options.onError && typeof options.onError === "function") {
        options.onError(error);
      }
    });

  return true;
};

interface ShareOnWhatsAppOptions {
  text: string;
  phoneNumber?: string;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const shareOnWhatsApp = (options: ShareOnWhatsAppOptions): boolean => {
  const { text, phoneNumber } = options;

  let url = "https://wa.me/";
  if (phoneNumber) {
    url += `?phone=${encodeURIComponent(phoneNumber)}&text=${encodeURIComponent(
      text
    )}`;
  } else {
    url += `?text=${encodeURIComponent(text)}`;
  }

  window.open(url, "_blank");

  return true;
};

export const publishOnLinkedIn = (shareText: string) => {
  try {
    // Encode the text for URL compatibility
    const encodedText = encodeURIComponent(shareText?.trim());

    // LinkedIn share URL
    const linkedInShareURL = `https://www.linkedin.com/feed/?linkOrigin=LI_BADGE&shareActive=true&text=${encodedText}`;

    // Open LinkedIn share window
    window.open(linkedInShareURL, "_blank");
  } catch (error) {
    console.error("Error sharing to LinkedIn:", error);
  }
};

export function capitalizeFirstLetter(text: string): string {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1);
}
